export default __webpack_public_path__ + "static/media/DavidHariri.6eb79855.jpg";